import { useContext } from 'react';
import { FetchObjectAccessContext } from '../Context';

export const useFetchObjectAccess = () => {
  const fetch = useContext(FetchObjectAccessContext);

  return fetch;
};

export default useFetchObjectAccess;